import { bridge } from '../../bridge';
import { useCallback } from 'react';
import { useRootStackNavigation } from '../../../hooks/useRootNavigation';
import { appendParams, finalizeUrl, getDefaultDeeplink } from '../utils';

type moveToMarketHomeProps = {
  sno: number;
  categorySno?: number | null;
  showCoupons?: boolean;
  order?: string | null;
};

export const useMarketNavigator = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigation: any = useRootStackNavigation();

  const moveToMarketHome = useCallback(
    ({
      sno,
      categorySno = null,
      showCoupons = false,
      order = null,
    }: moveToMarketHomeProps) => {
      const url = getDefaultDeeplink();
      appendParams(url, 'screen', 'MarketHome');
      appendParams(
        url,
        'extras',
        JSON.stringify({
          category_sno: categorySno,
          show_coupons: showCoupons,
          order,
          sno,
        }),
      );
      bridge.openDeeplink(finalizeUrl(url), {
        webCallback: () => {
          navigation.navigate('MarketHome', {
            marketId: sno,
          });
        },
      });
    },
    [navigation],
  );

  return {
    moveToMarketHome,
  };
};
